import { map, Observable } from 'rxjs';
import { HostedGamesService } from '@hosted-games/infra';
import { inject } from '@angular/core';
import { DateFormatPipe } from '@ui-components';
import { mapToCreateGameResultUtil } from '../../utils/map-to-create-game-result.util';
import { UpdateHostedGamePathParams, UpdatePartialHostedGameDto, UpdateHostedGameResponse } from '@core-http';
import { CreateGameCommandResult } from '../create-game/create-game.command-result';

export class UpdateGameCommandHandler {
  private readonly hostedGamesService: HostedGamesService = inject(HostedGamesService);
  private readonly dateFormatPipe: DateFormatPipe = inject(DateFormatPipe);

  updateGame(gameId: string, game: Partial<UpdatePartialHostedGameDto>): Observable<CreateGameCommandResult> {
    const pathParams: UpdateHostedGamePathParams = { hostedGameId: gameId };

    return this.hostedGamesService
      .updateGame(pathParams, game)
      .pipe(map((response: UpdateHostedGameResponse) => mapToCreateGameResultUtil(response, this.dateFormatPipe)));
  }
}
